import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import * as fromApp from '../../app.reducer';
import { switchMap, map, flatMap } from 'rxjs/operators';
import { CurrentUser } from 'app/services/currentUser.service';
import { HeaderComponent } from 'app/header/header.component';
import { ShareService } from 'app/services/share.service';

@Component({
  selector: 'show-story-project',
  styleUrls: ['./show.component.scss'],
  templateUrl: './show.component.html',
  providers: [HeaderComponent],
})
export class ShowInvitationStoryComponent implements OnInit {
  done: boolean;
  isMobile;
  projectId;
  invitationToken;
  projectInfo;
  owner;
  guest;
  canEdit;
  Load;
  isguest: boolean;

  storyId;

  constructor(
    private store: Store<fromApp.AppState>,
    private currentUser: CurrentUser,
    private route: ActivatedRoute,
    private header: HeaderComponent,
    private shareService: ShareService,
 ) {

    this.projectId = this.route.snapshot.paramMap.get('uuid');
    this.invitationToken = this.route.snapshot.queryParamMap.get('token');
    this.done = this.route.snapshot.queryParamMap.get('done') === 'true';
  }

  ngOnInit() {
    this.isguest = this.currentUser.get() ? this.currentUser.get().guest : false;
  }
}
